import * as React from 'react'
import {Box, Typography} from "@mui/material"
import {batch} from "@preact/signals-react";
import {IconSeeker} from "@ui-seeker/core";

import { ImageSkuBlock, SkuInfoBlock } from "@components"
import { GROUPED_BY } from '@constants'
import { useBuildExternalURL } from "@hooks"
import {commonFiltersValue} from "@signals";
import {stockShareSkuDetailsFilters} from "../../signals";


export default function skuColumn() {
	return [{
		name: 'ean', label: 'Ean',
		options: { 
			display: 'excluded',
			filterType: 'textField'
		}
	}, {
		name: 'category', label: 'Category',
		options: { display: 'excluded' }
	}, {
		name: 'brand', label: 'Brand',
		options: { display: 'excluded' }
	}, {
		name: 'skuName', label: 'Product Name',
		options: { 
			display: 'excluded',
			filterType: 'textField'
		}
	}, {
		name: 'skuName', label: 'Product Name',
		options: {
			filter:false,
			headerAlign: 'center',
			customBodyRowRenderLite: (value, { category, brand, ean, skuName, skuID, productID, siteID, country, date, reference, externalSeller, siteIDFiltered }) => {
				const { imageURL, productURL } = useBuildExternalURL({
					imageData: { skuID, siteID, productID, date },
					siteData: { siteID, productID }
				})
				return <Box sx={{ display: 'flex', justifyContent: 'flex-start', alignItems: 'center', gap: 2 }}>
					<Box>
						<ImageSkuBlock imageURL={imageURL} />
					</Box>
					<Box>
						<SkuInfoBlock
							sku={value}
							category={category}
							brand={brand}
							ean={ean}
							reference={reference}
							productURL={productURL}
						/>
						<ShowSkuDetails
							skuID={skuID}
							sku={skuName}
							country={country}
							externalSeller={externalSeller}
							siteIDFiltered={siteIDFiltered}
							productID={productID}
						/>
					</Box>
				</Box>
			}
		}
	}]
}

const ShowSkuDetails = ({skuID, sku, country, externalSeller, siteIDFiltered, productID}) => {
    const handleClickDetails = () => { batch(() => {
        stockShareSkuDetailsFilters.value = {
            ...commonFiltersValue.peek(),
            sku: [skuID],
            country: [country],
            skuName: sku,
            splitKpi: GROUPED_BY.RETAILER,
			externalSeller: externalSeller,
			retailer: [siteIDFiltered],
			productID: productID
        }
    })}

    return <Box sx={{ display: 'flex', alignItems: 'flex-end'}} onClick={handleClickDetails} >
        <Typography variant="caption" sx={{ display: 'block', color: "text.primary", mt: 1, mr: 0.5, cursor: 'pointer', "&:hover":{ fontWeight: 'bold' } }}>
            Show daily details
        </Typography>
        <IconSeeker icon={'magnifying-glass'} sx={{ mr: 0.5, margin: .5, color: 'primary.main'}}/>
    </Box>

}